// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import url from '../static/json/images'
import ElementUI from 'element-ui'
import Message from 'element-ui';
import Auth from './utils/auth'
import $$ from './utils/utils'
import Cookie from 'js-cookie'
import 'element-ui/lib/theme-chalk/index.css'
import toastRegistry from '@/components/toast/toast.js'
import { member } from "./api/login";
import '@/assets/css/swiper.css'
Vue.config.productionTip = false;
Vue.prototype.$url = url;
Vue.prototype.$auth = Auth;
Vue.prototype.$$ = $$;
Vue.prototype.$message = Message;
Vue.prototype.$isLogin = false;
import {Alert, Confirm, Toast} from 'wc-messagebox'
import 'wc-messagebox/style.css'
let options = {
  title: '', // 默认无标题
  yes: {
    text: '确定',
    style: {}
  },
  no: {
    text: '取消',
    style: {}
  }
}
Vue.use(Alert, options)
Vue.use(Confirm, options)
Vue.use(Toast, options)
const members = _=>{
  member().then(res=>{
    if (res){
      if(!res.avatar_url) res.avatar_url = 'https://www.1zyy.cn/img/default-header.jpg';
      Auth.setUserInfo(res);
      Vue.prototype.$isLogin = true;
      router.isLogin = true;
      // console.log(res)
    }
  })
}
members()
Vue.prototype.$member = members
Vue.use(ElementUI, toastRegistry)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App ref="app"/>'
})





// WEBPACK FOOTER //
// ./src/main.js